<div class="verify-email-container">
  <div class="branding">
    <img src="/favicon.ico" alt="Kitty On Demand Logo" class="branding-logo" />
  </div>
  <mat-card>
    <mat-card-title>Email Verification</mat-card-title>
    <mat-card-content>
      <form>
        <div class="verify-email-info">
          <p>
            We've sent a verification email to:
            <span class="user-email">{{ email }}</span>
          </p>
          <p>
            Please check your inbox and click the verification link.<br>
            <strong>If you don't see the email, check your spam or junk folder.</strong>
          </p>
        </div>
        <button mat-raised-button color="primary" type="button" (click)="resendVerification()" [disabled]="cooldown > 0 || loading" class="verify-email-button">
          <ng-container *ngIf="!loading; else loadingTpl">Resend Verification Email <span *ngIf="cooldown > 0">({{ cooldown }}s)</span></ng-container>
          <ng-template #loadingTpl>
            <mat-spinner diameter="24" color="accent"></mat-spinner>
          </ng-template>
        </button>
        <button mat-raised-button color="accent" type="button" (click)="checkVerified()" [disabled]="loading" class="verify-email-button">
          I've Verified
        </button>
        <button mat-button color="warn" type="button" (click)="logout()" [disabled]="loading" class="verify-email-button">
          Logout
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
